import React from 'react';
import './loader.component.scss';
import EventManager from '../../../common/services/event-manager.service';
import Loader from 'b2b-ui-components-lib/lib/components/roundLoader';
class MainLoader extends React.PureComponent {
  state = {
    loaderClass: ''
  };
  componentDidMount() {
    this.addLoaderListener();
  }

  addLoaderListener = () => {
    EventManager.subscribe('loader', (show) => {
      this.setState({ loaderClass: show ? 'loading show' : 'loading hide' });
    });
  };

  render() {
    return (
      <React.Fragment>
        {this.props && this.props.textLoader ? (
          <div className="loader1">
            <div className="round-loader">
              <Loader />
              <p className="loader-heading">
                <span className="color-red">Loading…</span>
                <br />
                Please Wait.
              </p>
            </div>
          </div>
        ) : (
          <div className={this.state.loaderClass}>
            <div className="container1">
              <div className="round-loader">
                <Loader />
                <p className="loader-heading">
                  <span className="color-red">Loading…</span>
                  <br />
                  Please Wait.
                </p>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
export default MainLoader;
